import React from 'react';

const MARQUEE_ITEMS = [
  { icon: '💪', text: 'High Protein' },
  { icon: '🌾', text: 'High Fibre' },
  { icon: '🏠', text: 'Homemade' },
  { icon: '🚫', text: 'No Artificial Colours' },
  { icon: '🍬', text: 'No Refined Sugar' },
  { icon: '🌿', text: '100% Vegetarian' },
  { icon: '⚡', text: 'Ready in 3 Minutes' },
];

export function MarqueeStrip() {
  return (
    <div className="marquee-strip">
      <div className="marquee-track">
        {[...MARQUEE_ITEMS, ...MARQUEE_ITEMS].map((item, i) => (
          <span className="marquee-item" key={i}>
            <span className="marquee-icon">{item.icon}</span>
            {item.text}
          </span>
        ))}
      </div>
    </div>
  );
}
